import utils from '@/mixins/utils'

/**
 * Filtra a lista de cadastros conforme os filtros selecionados.
 *
 * @param {Array<Object>} cadastros Lista de cadastros a serem filtrados.
 * @param {Boolean} exibirVermelhos Indica se devem ser exibidos apenas os cadastros vermelhos.
 * @param {Boolean} exibirVerdes Indica se devem ser exibidos apenas os cadastros verdes.
 * @param {Object} equipe Equipe selecionada.
 * @param {Object|null} mes Mês selecionado no filtro.
 *
 * @returns {Array<Object>} Lista de cadastros filtrados.
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  equipe = null,
  mes = null
) {
  let cadastros_filtrados = cadastros

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      const umAtendimento = item.num_med_atend_pessoa == 1

      if (!mes) {
        return umAtendimento
      }

      const mesesSelecionados = mes.value || []
      const anoSelecionado = mes.nu_ano

      let dados = []

      try {
        dados =
          typeof item.dados === 'string'
            ? JSON.parse(item.dados)
            : item.dados || []
      } catch (e) {
        dados = []
      }

      const registroMes = dados.find((dado) => {
        return (
          Number(dado.nm) != 0 &&
          mesesSelecionados.includes(Number(dado.nu_mes)) &&
          Number(dado.nu_ano) === Number(anoSelecionado) &&
          equipe.ine_emulti == dado.nu_ine
        )
      })

      return umAtendimento && !!registroMes
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      const pessoasAtendidas = item.num_med_atend_pessoa > 1

      if (!mes) {
        return pessoasAtendidas
      }

      const mesesSelecionados = mes.value || []
      const anoSelecionado = mes.nu_ano

      let dados = []

      try {
        dados =
          typeof item.dados === 'string'
            ? JSON.parse(item.dados)
            : item.dados || []
      } catch (e) {
        dados = []
      }

      const registroMes = dados.find((dado) => {
        return (
          Number(dado.nm) != 0 &&
          mesesSelecionados.includes(Number(dado.nu_mes)) &&
          Number(dado.nu_ano) === Number(anoSelecionado) &&
          equipe.ine_emulti == dado.nu_ine
        )
      })

      return pessoasAtendidas && !!registroMes
    })
  }

  return cadastros_filtrados
}
